/**
 * Rack edit payload — fields that RackConfigUpdate accepts (no `name`).
 * Run: node --experimental-strip-types frontend/src/utils/rackEdit.logic.test.mjs
 */

/** 1U height in meters (standard rack unit). */
export const U_HEIGHT_M = 0.04445

export type RackEditForm = {
  type: string
  heightU: number
  isBlocked: boolean
  tenant?: string
  cascadeTenant?: boolean
  maxWeightKg?: number
  maxPowerW?: number
  widthM?: number
  depthM?: number
}

/** Body for PUT /api/datacenters/racks/{id}. Independent of RackEditModal JSX. */
export function rackUpdatePayload(form: RackEditForm): Record<string, unknown> {
  const u = Math.max(1, Math.floor(Number(form.heightU) || 42))
  const body: Record<string, unknown> = {
    type: form.type || 'server_rack',
    u_slots: u,
    height_m: Number((u * U_HEIGHT_M).toFixed(3)),
    is_blocked: Boolean(form.isBlocked),
  }
  if (form.tenant != null && form.tenant !== '') body.tenant = form.tenant
  if (form.cascadeTenant) body.cascade_tenant = true
  if (form.maxWeightKg != null && !Number.isNaN(form.maxWeightKg)) body.max_weight_kg = form.maxWeightKg
  if (form.maxPowerW != null && !Number.isNaN(form.maxPowerW)) body.max_power_w = form.maxPowerW
  if (form.widthM != null && !Number.isNaN(form.widthM)) body.width_m = form.widthM
  if (form.depthM != null && !Number.isNaN(form.depthM)) body.depth_m = form.depthM
  return body
}

export function rackDisplayTitle(rack: { label?: string; id?: number; name?: string } | null): string {
  if (!rack) return 'Стойка'
  if (rack.label) return rack.label
  if (rack.id != null) return `Стойка #${rack.id}`
  return 'Стойка'
}
